import { ProductData } from "../../../types/ProductService/ProductService";
import { translate } from "../../Translations/translatorService";
import { persistRentalContractCase } from "../../Persist/RentalContractPersister";
import * as caseStages from "../../Stages/StagesCase";
import { stageMetaDataCase } from "../../Stages/StagesCase";
import * as caseStatus from "../../LeadStatus/StatusCase";
import rentalContractTransformations from "../FormTransformations/rentalContractTransformations";
import { stageFormDefinition as stageFormDefinitionRentalContract } from "../FormDefinitions/rentalContract/stageFormDefinition";
import { fullFormDefinition as fullFormDefinitionRentalContract } from "../FormDefinitions/rentalContract/fullFormDefinition";
import { rentalContractCaseDetailsSpecialActions } from "../CaseDetailsSpecialActions/rentalContractCaseDetailsSpecialActions";
import { getRentalContractBadges } from "../Badges/getRentalContractBadges";
import { litigationCaseSubBarAdditionalInformation } from "../CaseSubBarAdditionalInformation/litigationCaseSubBarAdditionalInformation";
import { inquiryTypeAvailability } from "../../inquiryService";
import {
  litigationCaseCourtAppointmentCreationAvailable,
  placeholderPaymentTypeSwitchData,
} from "./productServiceFunctions";
import { getProductData } from "./productService";
import { RentalContract } from "../../../types/Products/RentalContract";

export const rentalContract: ProductData<RentalContract> = {
  urlPart: "miete",
  lbUrlPart: "miete",
  label: translate("rentalContract.label"),
  generalLabel: translate("rentalContract.label"),
  apiUri: "rental_contracts",
  persist: persistRentalContractCase,
  stages: stageMetaDataCase,
  stageConstants: caseStages,
  minimumCaseStatus: caseStatus.STATUS_CREATED,
  minimumCaseStage: caseStages.STAGE_CREATED,
  setBackCaseStage: caseStages.STAGE_DATA_COMPLETED,
  paymentType: {
    creditcard: "Kreditkarte",
    paypal: "Paypal",
    sofort: "Sofortüberweisung",
    insurance: "RSV",
  },
  paymentTypeSwitchData: placeholderPaymentTypeSwitchData,
  courtAppointmentCreationAvailable: litigationCaseCourtAppointmentCreationAvailable,
  lbProductClass: "App\\Entity\\Legalbird\\TenancyLaw\\RentalContract\\RentalContract",
  formTransformations: rentalContractTransformations,
  formDefinition: ({ product }) => stageFormDefinitionRentalContract(product),
  formDefinitionExternals: ({ product }) => stageFormDefinitionRentalContract(product)[product.stage],
  fullFormDefinition: ({ product, currentUser }) => fullFormDefinitionRentalContract(product, currentUser),
  caseDetailsSpecialActions: ({ product }) => rentalContractCaseDetailsSpecialActions(product),
  productCategory: "tenancyLaw",
  productSpecificBadges: ({ product }) => getRentalContractBadges(product),
  caseSubBarAdditionalInformation: ({ product, currentUser }) =>
    litigationCaseSubBarAdditionalInformation(product, currentUser),
  showCaseDescription: ({ product }) => {
    return product.stage >= getProductData(product.productClassName, "setBackCaseStage");
  },
  inquiryTypeAvailability: inquiryTypeAvailability.rentalContract,
};
